import React, { FC } from 'react';
import { Maybe } from 't2-graphql-types';
import Typo from '../Typography/Typo';
import ArticleInspireContainer from '../ArticleInspire/ArticleInspireContainer';
import { ArticleType } from '../Article/types';
import { ArticleInspirePosition } from '../ArticleInspire/constants';
import { PromptHeaderReplyButton } from './PromptHeaderReplyButton';
import { PromptSettingsLiveStatus } from '../Prompt/constants';
import { PromptMarkdownRenderer } from '../PromptMarkdownRenderer/PromptMarkdownRenderer';
import { ReplyToPromptStatus } from './constants';

type TPromptHeaderProps = {
  title: string;
  replyToPromptUrl: string;
  replyToPromptStatus: ReplyToPromptStatus;
  body: string;
  promptId: string;
  promptSettingsLiveStatus?: Maybe<PromptSettingsLiveStatus>;
  isPromptLoading?: boolean;
  isAuthenticatedUserLoading?: boolean;
  onReplyToPromptClick: () => void;
};

export const PromptHeader: FC<TPromptHeaderProps> = ({
  title,
  body,
  replyToPromptUrl,
  replyToPromptStatus,
  promptId,
  promptSettingsLiveStatus,
  isPromptLoading,
  isAuthenticatedUserLoading,
  onReplyToPromptClick,
}) => (
  <div className="flex mt-11 md:mt-24 lg:mt-32 flex-col items-start gap-y-6 lg:gap-y-10 col-span-full lg:col-start-2 lg:col-span-6 order-2 lg:order-1">
    <Typo variant="h1" className="w-full !text-[80px] !leading-[80px] break-words">
      {title}
    </Typo>
    <div className="w-full flex flex-col gap-y-4">
      <PromptMarkdownRenderer markdown={body} />
    </div>
    <div className="flex items-center">
      <ArticleInspireContainer
        position={ArticleInspirePosition.promptFooter}
        articleType={ArticleType.Prompt}
        articleId={promptId}
      />
    </div>
    <PromptHeaderReplyButton
      replyToPromptUrl={replyToPromptUrl}
      replyToPromptStatus={replyToPromptStatus}
      promptSettingsLiveStatus={promptSettingsLiveStatus}
      onReplyToPromptClick={onReplyToPromptClick}
      isPromptLoading={isPromptLoading}
      isAuthenticatedUserLoading={isAuthenticatedUserLoading}
    />
  </div>
);
